import React from 'react';
import { ButtonStyled } from '@nike/nike-design-system-components';
import { nike } from '@nike/nike-design-tokens';

import { GroupsInAcctMgmtModal } from '../modals';

import useModal from '../../../hooks/useModal';

const { podiumCdsColorTextPrimaryInverse } = nike;

const ViewProductContractGroups = () => {
  const [isModalOpen, openModal, closeModal] = useModal();

  return (
    <>
      <ButtonStyled type='button' background='light' size='small' onClick={openModal}>
        <span style={{ color: podiumCdsColorTextPrimaryInverse }}>Product Contract Groups</span>
      </ButtonStyled>
      <GroupsInAcctMgmtModal closeModal={closeModal} isOpen={isModalOpen} />
    </>
  );
};

export default ViewProductContractGroups;
